import script from "./remover-details.vue?vue&type=script&lang=ts&setup=true"
export * from "./remover-details.vue?vue&type=script&lang=ts&setup=true"

import "./remover-details.vue?vue&type=style&index=0&id=198c2861&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198c2861"]])

export default __exports__